import React, { Fragment, useState, useEffect } from "react";
import { useSelector } from "react-redux";
import { NavLink, useNavigate } from "react-router-dom";

import CartWineItem from "./CartWineItem";
import CartResultBlock from "./CartResultBlock";

import "./WineCart.css";

function WineCart() {

  const [itemsAmount, setItemsAmount] = useState(0);
  const navigate = useNavigate();

  const itemsInCart = useSelector(state => state.wines.cart);
  const amount = itemsInCart.reduce((r, v) => r + v.amount, 0);

  const handleAddMore = () => {
  if (itemsInCart.length === 0) return;

  const firstItem = itemsInCart[0].item;

  navigate(
    `/shopitem?mode=addmore&site_id=${firstItem.site_id}&cat_id=${firstItem.cat_id}&bm_id=${firstItem.bm_id}`
  );
};

useEffect(() => {
  setItemsAmount(amount);
}, [amount]);

  let cartItemsCode;
 if (itemsInCart.length > 0) {
  cartItemsCode = itemsInCart.map((v) => (
    <CartWineItem
       key={v.item.id}
  bm_id={v.item.bm_id}
  itemId={v.item.id}   // unique cart item id (includes size suffix)
    />
  ));
}

  return (
    <Fragment>
     
      <div className="cart-header">

<NavLink to="/" className="cart-link">
  Rs INR choose wine
</NavLink>

<div className="cart-title-row">

  <div className="cart-title-left">

    <div className="cart-decoration-block"></div>

    <h1 className="cart-title">Cart</h1>

    <span className="cart-title-info">
      (items in cart: {itemsAmount})
    </span>

  </div>

  {itemsInCart.length > 0 && (
    <button
      className="cart-addmore-top-btn"
      onClick={handleAddMore}
    >
      Add More
    </button>
  )}

</div>

</div>

      <div className="cart-items-block">
        {cartItemsCode}
      </div>

      <CartResultBlock />
    </Fragment>
  );
}

export default WineCart;
